<template>
    <div>
        <base-header type="gradient-success" class="pb-6 ">
        </base-header>

        <ShowRestaurant />
    </div>
</template>
<script>
    import ShowRestaurant from "../../components/Restaurant/ShowRestaurant";
    export default {
        components: {ShowRestaurant}
    }
</script>